export default __webpack_public_path__ + "static/media/kb-logo.02555c89.png";